import * as React from 'react';
import { ResponsiveStyleValue, SpacingValue } from '../../theming';
import { CardOrientation } from '../../theming/types/components/Card.types';

export interface CardContextValues {
    padding?: ResponsiveStyleValue<SpacingValue>;
    orientation?: ResponsiveStyleValue<CardOrientation>;
    selected: boolean;
}

export const CardContext = React.createContext<CardContextValues>({ selected: false });

export function useCard(): CardContextValues {
    return React.useContext(CardContext);
}
